<template>
    <ol class="breadcrumb">
        <li v-for="(link, index) in linksWithDashboard" :class="{'active': isLast(index)}">
            <router-link v-if="link.url && !isLast(index)" :to="link.url">
                {{ link.text }}
            </router-link>

            <span v-else>
                {{ link.text }}
            </span>
        </li>
    </ol>
</template>

<script>
    export default {
        props: ['links'],

        computed: {
            linksWithDashboard() {
                return [{url: '/dashboards/my-focus', text: 'My Focus'}].concat(this.links);
            }
        },

        methods: {
            isLast(index) {
                return index === this.linksWithDashboard.length - 1;
            }
        }
    }
</script>
